import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import {
  CarImageContainer,
  CarModelText,
  Container,
  DeliveryBadge,
  DeliveryText,
  Header,
  LocationText,
  LogoContainer,
  MarketPriceText,
  PriceCard,
  PriceText,
  SubtitleText
} from "./styles";
import { CommonProps } from "@utils/interface";
import { convertToLakhMin } from "@utils/inrFormatter";
import { monthMap } from "@utils/index";

interface AckoDriveNudgeModalProps extends CommonProps {
  brandId?: number | null;
  brandName?: string | null;
  modelId?: number | null;
  modelName?: string | null;
  variantId?: number | null;
  variantName?: string | null;
  ackoVariantId?: number | null;
  city?: string | null;
  colorId?: number | null;
  colorName?: string | null;
  expressDeliverDate?: number[] | null;
  onroadPrice?: number | null;
  ackodrivePrice?: number | null;
  landingPageUrl?: string | null;
  imageUrl?: string | null;
}

const AckoDriveNudgeModal = (props: AckoDriveNudgeModalProps) => {
  const { actions } = props
  //@ts-ignore
  const { on_click } = actions
  const {
    brandId,
    brandName,
    modelId,
    modelName,
    variantId,
    variantName,
    ackoVariantId,
    city,
    colorId,
    colorName,
    expressDeliverDate,
    onroadPrice,
    ackodrivePrice,
    landingPageUrl,
    imageUrl
  } = props;

  const onClose = () => {
    if (on_click && on_click?.length > 0) {
      on_click?.forEach((eachFunc: any) => {
        console.log(eachFunc)
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall({
            ...eachFunc.args,
          });
      });
    }
  }

  return (
    <Container>
      <Header>
        <LogoContainer>
          <ImageContainer
            imgSrc={resolvePath("/images/ACKODriveHorizontal.svg")}
            alt="car"
            width={90}
            height={30}
          />
        </LogoContainer>
        <ImageContainer
          imgSrc={resolvePath("/images/close-icon.svg")}
          alt="car"
          width={24}
          height={24}
          style={{ cursor: "pointer" }}
          onClick={onClose}
        />
      </Header>
      <SubtitleText>Get your</SubtitleText>
      <CarModelText>{brandName} {modelName} {variantName}</CarModelText>
      <CarImageContainer>
        <ImageContainer
          imgSrc={imageUrl}
          alt="car"
          width={208}
          height={104}
        />
      </CarImageContainer>
      <PriceCard>
        <DeliveryBadge>
          <ImageContainer
            imgSrc={resolvePath("/images/lightning.svg")}
            alt="car"
            width={16}
            height={16}
          />
          {expressDeliverDate ? <DeliveryText>Express delivery by {expressDeliverDate[0]} {monthMap[expressDeliverDate[1]]} '{expressDeliverDate[2]}</DeliveryText> : null}
        </DeliveryBadge>
        {city ? <LocationText>ACKO Drive price, {city}</LocationText> : null}
        {ackodrivePrice ? <PriceText>₹{convertToLakhMin(ackodrivePrice, false, 1)} lakh</PriceText> : null}
        {onroadPrice ? <MarketPriceText>Market price - ₹{convertToLakhMin(onroadPrice, false, 1)} lakh</MarketPriceText> : null}
      </PriceCard>
    </Container>
  );
};

export default AckoDriveNudgeModal;
